import { render, staticRenderFns } from "./no_rights.vue?vue&type=template&id=16ef4afa&scoped=true&"
import script from "./no_rights.vue?vue&type=script&lang=js&"
export * from "./no_rights.vue?vue&type=script&lang=js&"
import style0 from "./no_rights.vue?vue&type=style&index=0&id=16ef4afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef4afa",
  null
  
)

export default component.exports